import { NavLink, useNavigate } from "react-router-dom";
import { useAuthStore } from "@/store/auth.js";

const navItems = [
  { to: "/tenants", label: "사찰 목록", icon: "⛩" },
  { to: "/admins", label: "관리자 관리", icon: "👥" },
  { to: "/settings", label: "사이트 설정", icon: "⚙️" },
];

export function Sidebar() {
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();

  async function handleLogout() {
    await logout();
    navigate("/login", { replace: true });
  }

  return (
    <aside className="flex h-screen w-56 shrink-0 flex-col border-r border-gray-200 bg-white">
      <div className="px-5 py-5">
        <span className="text-sm font-bold text-brand-600">슈퍼관리자</span>
      </div>
      <nav className="flex-1 px-2 py-2">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `flex items-center gap-2.5 rounded-lg px-3 py-2.5 text-sm transition-colors ${
                isActive
                  ? "bg-brand-50 font-semibold text-brand-700"
                  : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
              }`
            }
          >
            <span className="text-base">{item.icon}</span>
            {item.label}
          </NavLink>
        ))}
      </nav>
      <div className="border-t border-gray-100 px-4 py-4">
        <p className="truncate text-xs text-gray-400">{user?.email}</p>
        <button
          onClick={handleLogout}
          className="mt-2 w-full rounded-lg px-3 py-2 text-left text-sm text-gray-500 transition-colors hover:bg-gray-50 hover:text-gray-700"
        >
          로그아웃
        </button>
      </div>
    </aside>
  );
}
